import { render, staticRenderFns } from "./FileAClaim.vue?vue&type=template&id=c7f54e7e"
import script from "./FileAClaim.vue?vue&type=script&lang=ts"
export * from "./FileAClaim.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports